module.exports = __webpack_public_path__ + "img/location.ad5e2147.png";